import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import DrawerCustom from '../../components/DrawerCustom';
import { Grid, ListItem, ListItemText } from '@material-ui/core';
import CustomizedCircularProgress from '../../components/CircularProgress';

const styles = theme => ({
    boxItemContent: {
        padding: theme.spacing(4),
        marginBottom: theme.spacing(1.5),
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        cursor: 'pointer'
    },
});

class MerrchantVenueStore extends Component {
    render() {
        const { classes, t, data } = this.props
        return (
            <div>
                <DrawerCustom open={this.props.open} onClose={this.props.onClose}
                    title={t('merchants_title')}
                    enableBack
                >
                    {this.props.showLoading && <Grid xs={12} item container justify='center' alignItems='center'>
                        <CustomizedCircularProgress />
                    </Grid>}
                    {data.length > 0 && <Grid xs={12} item className={classes.boxItemContent}>
                        {data.map((item, index) => (
                            <ListItem divider button onClick={() => this.props.onUpdatePreferrence(item)}>
                                <ListItemText primary={item.name} />
                            </ListItem>))}
                    </Grid>}
                </DrawerCustom>
            </div>
        );
    }
}

export default withStyles(styles)(withTranslation()(MerrchantVenueStore));